(function () {
"use strict";
const options_collection = {
  collectionsLoadMore: ".collections-load-more",
  rangeSlider: ".price-range .range-slider",
  rangeSliderMin: ".range-slider-min",
  rangeSliderMax: ".range-slider-max",
  minPriceRange: ".min-price-range",
  maxPriceRange: ".max-price-range",
  collectionSidebar: "#CollectionSidebar",
  collectionFilterBlocks: ".filter-blocks",
  productgridcontainer: "#productgridcontainer",
  collectionFiltersForm: "#CollectionFiltersForm",
  section: ".sec__collection-main",
};

class BtnFilter extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onOpen.bind(this), false);
  }
  get sidebar() {
    return document.getElementById("CollectionSidebar");
  }
  onOpen() {
    const sidebar = this.sidebar;
    if (!sidebar) return;
    if (!this.classList.contains("open")) {
      sidebar.classList.add("open");
      document.documentElement.classList.add("open-drawer", "open-sidebar");
      root.style.setProperty("padding-right", getScrollBarWidth.init() + "px");
      this.classList.add("open");
    } else {
      sidebar.classList.remove("open");
      document.documentElement.classList.remove("open-drawer", "open-sidebar");
      root.style.removeProperty("padding-right");
      this.classList.remove("open");
    }
  }
}
customElements.define("btn-filter", BtnFilter);

class CloseFilter extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onClose.bind(this), false);
  }
  get sidebar() {
    return document.getElementById("CollectionSidebar");
  }
  onClose() {
    const sidebar = this.sidebar;
    if (!sidebar) return;
    sidebar.classList.remove("open");
    document.documentElement.classList.remove("open-drawer", "open-sidebar");
    const btnFilter = document.querySelector(".btn-filter");
    if (btnFilter) btnFilter.classList.remove("open");
    root.style.removeProperty("padding-right");
  }
}
customElements.define("close-filter", CloseFilter);

class FacetApplyCanvas extends CloseFilter {
  constructor() {
    super();
    this.addEventListener("click", this.onClose.bind(this), false);
  }
}
customElements.define("facet-apply-canvas", FacetApplyCanvas);

class GridMode extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.gridMode.bind(this), false);
  }
  gridMode() {
    const view_mode = this.getAttribute("data-grid-mode");
    if (this.classList.contains("active")) return;
    if (view_mode == 1) return;
    for (var item of document.querySelectorAll("grid-mode")) {
      item.classList.remove("active");
    }
    const container_switch = document.querySelector(
      ".container-products-switch"
    );
    this.classList.add("active");
    const data_view_mode = container_switch.getAttribute("data-view-mode");
    container_switch.classList.remove("grid-columns-" + data_view_mode);
    container_switch.setAttribute("data-view-mode", view_mode);
    container_switch.classList.add("grid-columns-" + view_mode);
    
    // Store user preference in sessionStorage
    try {
      sessionStorage.setItem('texasArtSupply_gridMode', view_mode);
    } catch (e) {
      console.warn('Could not save grid mode preference:', e);
    }
  }
}
customElements.define("grid-mode", GridMode);

class ViewMode extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.viewMode.bind(this), false);
  }
  viewMode() {
    const view_mode = this.getAttribute("data-view");
    if (this.classList.contains("actived")) return;
    var queryString = window.location.search;
    queryString = eventCollectionShopify.removeParam("view", queryString);
    if (view_mode == "list") {
      var searchParams = queryString.replace("?", "") + "&view=list";
      // Store user preference in sessionStorage
      try {
        sessionStorage.setItem('texasArtSupply_viewMode', 'list');
      } catch (e) {
        console.warn('Could not save view mode preference:', e);
      }
    } else {
      var searchParams = queryString.replace("?", "") + "&view=grid";
      // Store user preference in sessionStorage
      try {
        sessionStorage.setItem('texasArtSupply_viewMode', 'grid');
      } catch (e) {
        console.warn('Could not save view mode preference:', e);
      }
    }
    const url = eventCollectionShopify.renderUrl(searchParams);
    eventCollectionShopify.renderSectionFilter(url, searchParams);
  }
}
customElements.define("view-mode", ViewMode);

// Document-level capture listener intercepts ALL filter-item clicks before any
// element-level handler (including third-party apps like Globo Pre-Order that may
// register their own "filter-item" custom element and cause page navigation instead
// of AJAX). Capture phase fires before bubble phase, so stopPropagation() here
// prevents Globo's handler from ever receiving the event.
document.addEventListener("click", function(event) {
  const filterItem = event.target.closest("filter-item");
  if (!filterItem) return;

  event.preventDefault();
  event.stopPropagation();

  // Toggle visual state immediately (optimistic UI)
  const tooltipEl = filterItem.querySelector(".tooltip");
  const checkboxEl = filterItem.querySelector(".checkbox");
  if (tooltipEl) {
    tooltipEl.classList.toggle("current-filter");
  } else {
    const li = filterItem.closest("li");
    if (li) li.classList.toggle("current-filter");
    if (checkboxEl) checkboxEl.classList.toggle("checked");
  }

  const url = filterItem.getAttribute("data-href");
  if (url) eventCollectionShopify.renderSectionFilter(url);
}, true); // true = capture phase

class FilterItem extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.filterItem.bind(this), false);
  }
  filterItem() {
    if (this.querySelector(".tooltip")) {
      this.querySelector(".tooltip").classList.toggle("current-filter");
    } else {
      if (this.closest("li")) {
        this.closest("li").classList.toggle("current-filter");
      }
      const checkboxEl = this.querySelector(".checkbox");
      if (checkboxEl) {
        checkboxEl.classList.toggle("checked");
      }
    }
    const url = this.getAttribute("data-href");
    eventCollectionShopify.renderSectionFilter(url);
  }
}
if (!customElements.get("filter-item")) {
  customElements.define("filter-item", FilterItem);
}

class FacetClearAll extends CloseFilter {
  constructor() {
    super();
    this.addEventListener("click", this.filterItem.bind(this), false);
  }
  filterItem() {
    const url = this.getAttribute("data-href");
    eventCollectionShopify.renderSectionFilter(url);
    this.onClose();
  }
}
customElements.define("facet-clear-all", FacetClearAll);

class FilterSort extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.filterSort.bind(this), false);
  }
  
  filterSort() {
    // Store references to category elements before sorting
    this.storeCategoryElements();
    
    const value = this.getAttribute("value");
    let queryString = window.location.search;
    queryString = eventCollectionShopify.removeParam("sort_by", queryString);
    const searchParams = queryString.replace("?", "") + "&sort_by=" + value;
    const url = eventCollectionShopify.renderUrl(searchParams);
    eventCollectionShopify.renderSectionFilter(url, searchParams);
  }
  
  // Store references to category elements before sort operation
  storeCategoryElements() {
    // Preserve category data
    if (window.texasArtSupplyCategoryBubbles && window.texasArtSupplyCategoryBubbles.topCategories) {
      window._tempCategoryBubbles = {
        topCategories: [...window.texasArtSupplyCategoryBubbles.topCategories],
        originalCategories: [...window.texasArtSupplyCategoryBubbles.originalCategories],
        currentPath: [...window.texasArtSupplyCategoryBubbles.currentPath],
        initialized: window.texasArtSupplyCategoryBubbles.initialized
      };
    }
  }
}
customElements.define("filter-sort", FilterSort);

class SelectSorter extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.activeFilterSort.bind(this), false);
  }
  
  activeFilterSort() {
    if (this.closest(".select-custom").classList.contains("active")) {
      this.closest(".select-custom").classList.remove("active");
    } else {
      this.closest(".select-custom").classList.add("active");
    }
  }
}
customElements.define("select-sorter", SelectSorter);

// Global function to handle product image fallbacks
// This works across page loads and AJAX updates
window.initializeProductImageFallbacks = function() {
  try {
    // Only proceed if document is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', window.initializeProductImageFallbacks);
      return;
    }
    
    // Get all product images that need initialization
    const productImages = document.querySelectorAll('img.product-image[id^="product-image-"]');
    if (!productImages || productImages.length === 0) return;
    
    productImages.forEach(function(imgEl) {
      try {
        // Skip if element is no longer in the DOM
        if (!imgEl || !document.contains(imgEl)) return;
        
        // Skip if already processed AND has a valid image
        if (imgEl.dataset.fallbackInitialized === 'true' && 
            imgEl.complete && imgEl.naturalWidth > 0 && !imgEl.src.includes('image-not-found.jpg')) {
          return;
        }
        
        // Get the product ID from the image ID
        var productId = imgEl.id ? imgEl.id.replace('product-image-', '') : '';
        
        // Find all data sources in the parent nodes
        var parentNode = imgEl.closest('[data-family-image-url], [data-sku-image-url], [data-alt-sku-image-url]') 
                      || imgEl.closest('a') 
                      || imgEl.parentNode;
                      
        if (!parentNode || !document.contains(parentNode)) return;
        
        var familyImageUrl = parentNode.dataset ? (parentNode.dataset.familyImageUrl || '') : '';
        var skuImageUrl = parentNode.dataset ? (parentNode.dataset.skuImageUrl || '') : '';
        var altSkuImageUrl = parentNode.dataset ? (parentNode.dataset.altSkuImageUrl || '') : '';
        var notFoundUrl = (window.theme && window.theme.assets && window.theme.assets.image_not_found)
          || (window.Shopify && window.Shopify.shop ? `https://${window.Shopify.shop}/cdn/shop/files/image-not-found.jpg` : null);
        if (!notFoundUrl) notFoundUrl = '/assets/image-not-found.jpg';
        
        // Set up sources array
        var sources = [];
        if (familyImageUrl) sources.push(familyImageUrl);
        if (skuImageUrl) sources.push(skuImageUrl);
        if (altSkuImageUrl) sources.push(altSkuImageUrl);
        sources.push(notFoundUrl);
        
        // Skip if no sources found
        if (sources.length <= 1) return;
        
        var currentIndex = 0;
        
        function trySource() {
          if (currentIndex < sources.length) {
            var src = sources[currentIndex];
            // Make sure imgEl is still in the DOM
            if (imgEl && document.contains(imgEl)) {
              imgEl.src = src;
            }
          }
        }
        
        // Set up error handler once
        if (imgEl) {
          imgEl.onerror = function() {
            // Make sure imgEl is still in the DOM
            if (!imgEl || !document.contains(imgEl)) return;
            
            currentIndex++;
            trySource();
          };
          
          // Mark as initialized to avoid duplicate handlers
          imgEl.dataset.fallbackInitialized = 'true';
          
          // If image is showing the not-found image, try our sources
          // We do this check to avoid reloading an image that's already working
          if (!imgEl.complete || imgEl.naturalWidth === 0 || imgEl.src.includes('image-not-found.jpg')) {
            // Reset to first source and try sequence again
            currentIndex = 0;
            trySource();
          }
        }
      } catch (innerError) {
        console.error('Error processing product image:', innerError);
      }
    });
  } catch (error) {
    console.error('Error in initializeProductImageFallbacks:', error);
  }
};

// Initialize on page load
document.addEventListener('DOMContentLoaded', function() {
  window.initializeProductImageFallbacks();
});

// Category data manager - centralized approach for category data persistence
window.categoryManager = {
  originalData: null,
  
  // Save the current state of category data
  saveState: function() {
    if (window.texasArtSupplyCategoryBubbles) {
      this.originalData = {
        topCategories: window.texasArtSupplyCategoryBubbles.topCategories ? [...window.texasArtSupplyCategoryBubbles.topCategories] : [],
        originalCategories: window.texasArtSupplyCategoryBubbles.originalCategories ? [...window.texasArtSupplyCategoryBubbles.originalCategories] : [],
        currentPath: window.texasArtSupplyCategoryBubbles.currentPath ? [...window.texasArtSupplyCategoryBubbles.currentPath] : [],
        initialized: window.texasArtSupplyCategoryBubbles.initialized || false
      };
    }
  },
  
  // Restore category data after AJAX operations
  restoreState: function() {
    if (!this.originalData) return false;
    
    if (!window.texasArtSupplyCategoryBubbles) {
      window.texasArtSupplyCategoryBubbles = { 
        initialized: false,
        topCategories: [],
        currentPath: [], 
        originalCategories: []
      };
    }
    
    // Copy data back if we have it
    window.texasArtSupplyCategoryBubbles.initialized = this.originalData.initialized;
    window.texasArtSupplyCategoryBubbles.topCategories = [...this.originalData.topCategories];
    window.texasArtSupplyCategoryBubbles.originalCategories = [...this.originalData.originalCategories];
    window.texasArtSupplyCategoryBubbles.currentPath = [...this.originalData.currentPath];
    
    return true;
  },
  
  // Update category display - single efficient call
  updateCategoryDisplay: function() {
    // First restore our saved state
    this.restoreState();
    
    // Call updateCategoryDisplay if available
    if (typeof window.updateCategoryDisplay === 'function') {
      window.updateCategoryDisplay(false); // Pass false to prevent redundant processing
    }
    
    // Call category bubbles rendering, but only if we haven't already
    // The window._categoryBubblesRendered flag prevents multiple renderings
    if (!window._categoryBubblesRendered) {
      window._categoryBubblesRendered = true;
      
      if (typeof window.initializeCategoryBubbles === 'function') {
        window.initializeCategoryBubbles(false); // Pass false to prevent redundant processing
      } else if (typeof window.renderCategoryBubbles === 'function') {
        window.renderCategoryBubbles();
      }
    }
  }
};

// Initialize category manager on page load
document.addEventListener('DOMContentLoaded', function() {
  window.categoryManager.saveState();
});

var eventCollectionShopify = (function () {
  return {
    init: function () {
      this.ionRangeSlider();
      
      // Set default preferences for first-time visitors
      this.setDefaultGridPreference();
      
      // Apply saved grid view preference if available
      this.applyGridViewPreference();
      
      let windowWidth = window.innerWidth;
      if (windowWidth <= 1024) {
        const horizontal = document.querySelector(".horizontal-filter");
        if (horizontal) {
          const collapsible = document.querySelectorAll("collapsible-block");
          collapsible.forEach((e) => {
            e.classList.add("active");
          });
        }
      }
      
      // Save initial category state on page load
      if (window.categoryManager) {
        window.categoryManager.saveState();
      }
    },

    // Set default grid preferences for first-time visitors
    setDefaultGridPreference: function() {
      try {
        // Only set default if user has no saved preference
        if (!sessionStorage.getItem('texasArtSupply_gridMode')) {
          // Set default to 3 products per row
          sessionStorage.setItem('texasArtSupply_gridMode', '3');
        }
        
        // Set default view mode to grid if not set
        if (!sessionStorage.getItem('texasArtSupply_viewMode')) {
          sessionStorage.setItem('texasArtSupply_viewMode', 'grid');
        }
      } catch (e) {
        console.warn('Error setting default grid preference:', e);
      }
    },

    // Apply the saved grid view preference from sessionStorage
    applyGridViewPreference: function() {
      try {
        // Check for list/grid view preference first
        const savedViewMode = sessionStorage.getItem('texasArtSupply_viewMode');
        if (savedViewMode) {
          // Apply list/grid view preference via URL parameter
          // Only if we're not already on that view
          const currentViewMode = new URLSearchParams(window.location.search).get('view') || 'grid';
          if (currentViewMode !== savedViewMode) {
            let queryString = window.location.search;
            queryString = this.removeParam("view", queryString);
            const searchParams = queryString.replace("?", "") + "&view=" + savedViewMode;
            const url = this.renderUrl(searchParams);
            // Use setTimeout to delay this navigation slightly after page load
            setTimeout(() => {
              this.renderSectionFilter(url, searchParams);
            }, 50);
            return; // Exit early as we're changing pages
          }
        }

        // Then check for grid columns preference
        const savedGridMode = sessionStorage.getItem('texasArtSupply_gridMode');
        if (savedGridMode) {
          // Find the matching grid mode button
          const gridModeButton = document.querySelector(`grid-mode[data-grid-mode="${savedGridMode}"]`);
          const container_switch = document.querySelector(".container-products-switch");
          
          if (gridModeButton && container_switch) {
            // Remove active class from all grid mode buttons
            document.querySelectorAll('grid-mode').forEach(item => {
              item.classList.remove('active');
            });
            
            // Apply the saved grid mode
            gridModeButton.classList.add('active');
            const current_view_mode = container_switch.getAttribute('data-view-mode') || '3';
            container_switch.classList.remove('grid-columns-' + current_view_mode);
            container_switch.setAttribute('data-view-mode', savedGridMode);
            container_switch.classList.add('grid-columns-' + savedGridMode);
          }
        }
      } catch (e) {
        console.warn('Error applying saved grid mode:', e);
      }
    },

    ionRangeSlider: function () {
      const price_range = document.querySelector(".price-range");
      const maxRange = document.querySelector(
        options_collection.rangeSliderMax
      );
      const minRange = document.querySelector(
        options_collection.rangeSliderMin
      );
      const minPrice = document.querySelector(".min-price-range");
      const maxPrice = document.querySelector(".max-price-range");
      var minPriceRange = 0;
      var maxPriceRange = 0;
      if (!price_range) return;

      // Helper function to format price with 2 decimal places
      const formatPriceValue = (value) => {
        return parseFloat(value).toFixed(2);
      };

      // Add event listener for the Apply button
      const applyButton = document.querySelector(".price-range-apply");
      if (applyButton) {
        applyButton.addEventListener("click", (event) => {
          event.preventDefault();
          const formData = new FormData(
            document.querySelector(options_collection.collectionFiltersForm)
          );
          const params = new URLSearchParams(formData).toString();
          const nameMin = minPrice.getAttribute("name");
          const nameMax = maxPrice.getAttribute("name");
          var queryString = window.location.search;
          queryString = this.removeParam(nameMin, queryString);
          queryString = this.removeParam(nameMax, queryString);
          var searchParams = queryString.replace("?", "") + "&" + params;
          const url = this.renderUrl(searchParams);
          this.renderSectionFilter(url, searchParams);
        });
      }

      document
        .querySelector(options_collection.minPriceRange)
        .addEventListener(
          "change",
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            target.value = target.value.replace(',','')
            if (Number(minRange.min) + Number(target.value) >= 0) {
              if (Number(target.value) > Number(maxRange.max)) {
                minPrice.value = formatPriceValue(maxRange.max);
              } else {
                minPrice.value = formatPriceValue(target.value);
              }
            } else {
              minPrice.value = formatPriceValue(minRange.min);
            }
            const formData = new FormData(
              document.querySelector(options_collection.collectionFiltersForm)
            );
            const params = new URLSearchParams(formData).toString();
            const nameMin = minPrice.getAttribute("name");
            const nameMax = maxPrice.getAttribute("name");
            var queryString = window.location.search;
            queryString = this.removeParam(nameMin, queryString);
            queryString = this.removeParam(nameMax, queryString);
            var searchParams = queryString.replace("?", "") + "&" + params;
            const url = this.renderUrl(searchParams);
            this.renderSectionFilter(url, searchParams);
          },
          false
        );
      document
        .querySelector(options_collection.maxPriceRange)
        .addEventListener(
          "change",
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            target.value = target.value.replace(',','')
            if (Number(maxRange.max) - Number(target.value) >= 0) {
              maxPrice.value = formatPriceValue(target.value);
            } else {
              maxPrice.value = formatPriceValue(maxRange.max);
            }
            const formData = new FormData(
              document.querySelector(options_collection.collectionFiltersForm)
            );
            const params = new URLSearchParams(formData).toString();
            const nameMin = minPrice.getAttribute("name");
            const nameMax = maxPrice.getAttribute("name");
            var queryString = window.location.search;
            queryString = this.removeParam(nameMin, queryString);
            queryString = this.removeParam(nameMax, queryString);
            var searchParams = queryString.replace("?", "") + "&" + params;
            const url = this.renderUrl(searchParams);
            this.renderSectionFilter(url, searchParams);
          },
          false
        );
      document
        .querySelector(options_collection.rangeSliderMin)
        .addEventListener(
          "input",
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            if (Number(maxRange.value) - Number(target.value) >= 1) {
              minPrice.value = formatPriceValue(target.value);
              minPriceRange = Number(target.value) * 100;
            } else {
              target.value = Number(maxRange.value) - 1;
              minPriceRange = (Number(maxRange.value) - 1) * 100;
            }
            const price_format = Shopify.formatMoney(
              minPriceRange,
              cartStrings.money_format
            );
            document.querySelector(".price-lable .min").innerHTML =
              price_format;
            target
              .closest(".price-range")
              .style.setProperty(
                "--range-from",
                (minRange.value / Number(target.getAttribute("max"))) * 100 +
                  "%"
              );
          },
          false
        );
      document
        .querySelector(options_collection.rangeSliderMax)
        .addEventListener(
          "input",
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            if (target.value - minRange.value >= 1) {
              maxPrice.value = formatPriceValue(target.value);
              maxPriceRange = Number(target.value) * 100;
            } else {
              target.value = Number(minRange.value) + Number(1);
              maxPriceRange = (Number(minRange.value) + Number(1)) * 100;
            }
            const price_format = Shopify.formatMoney(
              maxPriceRange,
              cartStrings.money_format
            );
            document.querySelector(".price-lable .max").innerHTML =
              price_format;
            target
              .closest(".price-range")
              .style.setProperty(
                "--range-to",
                (maxRange.value / Number(target.getAttribute("max"))) * 100 +
                  "%"
              );
          },
          false
        );
      document
        .querySelectorAll(options_collection.rangeSlider)
        .forEach((sliderRange) => {
          sliderRange.addEventListener(
            "change",
            (event) => {
              event.preventDefault();
              const target = event.currentTarget;
              const formData = new FormData(
                document.querySelector(options_collection.collectionFiltersForm)
              );
              const params = new URLSearchParams(formData).toString();
              const nameMin = minPrice.getAttribute("name");
              const nameMax = maxPrice.getAttribute("name");
              var queryString = window.location.search;
              queryString = this.removeParam(nameMin, queryString);
              queryString = this.removeParam(nameMax, queryString);
              var searchParams = queryString.replace("?", "") + "&" + params;
              const url = this.renderUrl(searchParams);
              this.renderSectionFilter(url, searchParams);
            },
            false
          );
        });
    },

    removeParam: function (key, sourceURL) {
      var rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString =
          sourceURL.indexOf("?") !== -1 ? sourceURL.split("?")[1] : "";
      if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split("=")[0];
          if (param === key) {
            params_arr.splice(i, 1);
          }
        }
        if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
      }
      return rtn;
    },

    renderUrl: function (searchParams) {
      const sectionId = document.querySelector(options_collection.section)
        .dataset.sectionId;
      const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
      return url;
    },

    renderSectionFilter: function (url, searchParams) {
      // Start loading indicator
      this.toggleLoading(document.body, true);
      
      // Reset rendering flag for this operation
      window._categoryBubblesRendered = false;
      
      // Save category state before filter operation if not already saved
      if (window.categoryManager && !window.categoryManager.originalData) {
        window.categoryManager.saveState();
      }
      
      // Save the current price range slider positions to restore after content update
      const currentMinPrice = document.querySelector(options_collection.rangeSliderMin)?.value || 0;
      const currentMaxPrice = document.querySelector(options_collection.rangeSliderMax)?.value || 0;
      const currentMinInput = document.querySelector(options_collection.minPriceRange)?.value || 0;
      const currentMaxInput = document.querySelector(options_collection.maxPriceRange)?.value || 0;
      const maxRangeValue = document.querySelector(options_collection.rangeSliderMax)?.getAttribute('max') || 0;
      
      fetch(`${url}`)
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.status);
          }
          return response.text();
        })
        .then((responseText) => {
          try {
            // Update the DOM with new content
            if (window.innerWidth <= 1024) {
              // Mobile view update
              
              // Capture sidebar open state BEFORE any DOM changes
              const sidebarWasOpen = document.querySelector(options_collection.collectionSidebar)?.classList.contains("open");
              
              const parser = new DOMParser();
              const htmlDoc = parser.parseFromString(responseText, "text/html");
              
              // Update filter blocks
              const collectionFilterBlocks = htmlDoc.querySelector(options_collection.collectionFilterBlocks);
              if (collectionFilterBlocks) {
                const targetFilterBlocks = document.querySelector(options_collection.collectionFilterBlocks);
                if (targetFilterBlocks) {
                  targetFilterBlocks.innerHTML = collectionFilterBlocks.innerHTML;
                }
              }
              
              // Update product grid
              const productGridContainer = htmlDoc.querySelector(options_collection.productgridcontainer);
              if (productGridContainer) {
                const targetGridContainer = document.querySelector(options_collection.productgridcontainer);
                if (targetGridContainer) {
                  targetGridContainer.innerHTML = productGridContainer.innerHTML;
                }
              }
              
              // Restore sidebar open state if it was open before the update
              if (sidebarWasOpen) {
                const sidebar = document.querySelector(options_collection.collectionSidebar);
                if (sidebar) sidebar.classList.add("open");
                document.documentElement.classList.add("open-sidebar", "open-drawer");
                document.querySelector(".btn-filter")?.classList.add("open");
              }
            } else {
              // Desktop view update - replace entire section
              const newSection = new DOMParser()
                .parseFromString(responseText, "text/html")
                .querySelector(options_collection.section);
                
              if (newSection) {
                const currentSection = document.querySelector(options_collection.section);
                if (currentSection) {
                  currentSection.replaceWith(newSection);
                }
              }
            }
            
            // Remove any open drawer classes
            document.documentElement.classList.remove("hside_opened");
            
            // Initialize products and restore categories in a single batch
            this.initializeAfterContentUpdate();
            
            // Restore the price range slider positions
            this.restorePriceRangePosition(currentMinPrice, currentMaxPrice, currentMinInput, currentMaxInput, maxRangeValue);
          } catch (error) {
            console.error("Error updating collection content:", error);
          } finally {
            // Stop loading indicator
            this.toggleLoading(document.body, false);
          }
        })
        .catch((error) => {
          console.error("Error loading collection:", error);
          this.toggleLoading(document.body, false);
        })
        .finally(() => {
          // Initialize lazy loading
          if (typeof initLazyloadItem === 'function') {
            initLazyloadItem();
          }
          
          // Reinitialize range sliders
          this.ionRangeSlider();
        });
        
      // Update URL in browser history
      this.updateUrl(url, searchParams);
    },
    
    // Restore price range slider positions after content update
    restorePriceRangePosition: function(minPrice, maxPrice, minInput, maxInput, maxRange) {
      try {
        const minSlider = document.querySelector(options_collection.rangeSliderMin);
        const maxSlider = document.querySelector(options_collection.rangeSliderMax);
        const minPriceInput = document.querySelector(options_collection.minPriceRange);
        const maxPriceInput = document.querySelector(options_collection.maxPriceRange);
        const priceRange = document.querySelector(".price-range.drop-range");
        
        if (minSlider && maxSlider && priceRange) {
          // Only restore if the values are valid
          if (Number(minPrice) >= 0 && Number(maxPrice) > 0 && Number(maxPrice) >= Number(minPrice)) {
            // Update range slider values
            minSlider.value = minPrice;
            maxSlider.value = maxPrice;
            
            // Update text input values if they exist
            if (minPriceInput) minPriceInput.value = minInput;
            if (maxPriceInput) maxPriceInput.value = maxInput;
            
            // Calculate and update the range style for the visual indicator
            if (maxRange && maxRange > 0) {
              const from = (Number(minPrice) / Number(maxRange)) * 100;
              const to = (Number(maxPrice) / Number(maxRange)) * 100;
              priceRange.style.setProperty('--range-from', `${from}%`);
              priceRange.style.setProperty('--range-to', `${to}%`);
            }
          }
        }
      } catch (error) {
        console.error("Error restoring price range position:", error);
      }
    },
    
    // Consolidated initialization after content update
    initializeAfterContentUpdate: function() {
      // Batch 1: Handle product images (most important for user)
      if (typeof window.initializeProductImageFallbacks === 'function') {
        window.initializeProductImageFallbacks();
      }
      
      // Batch 2: Fix UI elements
      this.fixInteractiveElements();
      
      // Batch 3: Apply grid view preferences
      this.applyGridAfterContentUpdate();
      
      // Batch 4: Restore and update categories (can be slightly delayed)
      if (window.categoryManager) {
        requestAnimationFrame(() => {
          window.categoryManager.updateCategoryDisplay();
        });
      }
    },
    
    // Apply grid view preferences after content update
    applyGridAfterContentUpdate: function() {
      try {
        // Apply grid columns preference
        const savedGridMode = sessionStorage.getItem('texasArtSupply_gridMode');
        if (savedGridMode) {
          // Update grid mode button state
          const gridModeButton = document.querySelector(`grid-mode[data-grid-mode="${savedGridMode}"]`);
          if (gridModeButton) {
            // Remove active class from all grid mode buttons
            document.querySelectorAll('grid-mode').forEach(item => {
              item.classList.remove('active');
            });
            
            // Make the saved mode button active
            gridModeButton.classList.add('active');
          }
          
          // Update container class
          const container_switch = document.querySelector(".container-products-switch");
          if (container_switch) {
            const current_view_mode = container_switch.getAttribute('data-view-mode') || '3';
            if (current_view_mode !== savedGridMode) {
              container_switch.classList.remove('grid-columns-' + current_view_mode);
              container_switch.setAttribute('data-view-mode', savedGridMode);
              container_switch.classList.add('grid-columns-' + savedGridMode);
            }
          }
        }
        
        // Apply view mode active state
        const savedViewMode = sessionStorage.getItem('texasArtSupply_viewMode');
        if (savedViewMode) {
          const viewModeButton = document.querySelector(`view-mode[data-view="${savedViewMode}"]`);
          if (viewModeButton && !viewModeButton.classList.contains('actived')) {
            // Remove active class from all view mode buttons
            document.querySelectorAll('view-mode').forEach(item => {
              item.classList.remove('actived');
            });
            
            // Make the saved mode button active
            viewModeButton.classList.add('actived');
          }
        }
      } catch (e) {
        console.warn('Error applying grid preferences after content update:', e);
      }
    },
    
    // Fix all interactive elements in one consolidated function 
    fixInteractiveElements: function() {
      try {
        // 1. Fix loading overlays
        document.querySelectorAll('.loading-overlay').forEach(overlay => {
          if (!overlay || !document.contains(overlay)) return;
          overlay.style.pointerEvents = 'none';
          overlay.style.display = 'none';
          overlay.classList.add('pointer-none');
        });
        
        // 2. Ensure containers don't block interaction
        document.querySelectorAll('.product-grid-container').forEach(container => {
          if (!container || !document.contains(container)) return;
          container.style.position = 'static';
        });
        
        // 3. Fix any hidden grid items (addresses issue with products 7-9 not showing)
        document.querySelectorAll('#product-grid .grid__item').forEach((item, index) => {
          if (!item || !document.contains(item)) return;
          item.style.display = 'block';
          item.style.opacity = '1';
          item.style.visibility = 'visible';
          item.style.position = 'relative';
          item.style.zIndex = '1';
        });
        
        // 4. Ensure category links are interactive
        document.querySelectorAll('.category-child, .category-parent, .category-link, .hover-effect, .subcategory-name').forEach(item => {
          if (!item || !document.contains(item)) return;
          item.style.pointerEvents = 'auto';
          item.style.position = 'relative';
          item.style.zIndex = '1000';
        });
        
        // 5. Fix category link parents and children
        document.querySelectorAll('.category-child a, .category-parent a, .category-link, .hover-effect, .subcategory-name').forEach(link => {
          if (!link || !document.contains(link)) return;
          link.style.position = 'relative';
          link.style.zIndex = '101';
          link.style.pointerEvents = 'auto';
        });
      } catch (error) {
        console.error('Error in fixInteractiveElements:', error);
      }
    },
    
    // Store references to category elements before sort operation
    storeCategoryState: function() {
      if (window.categoryManager) {
        window.categoryManager.saveState();
      }
    },

    toggleLoading: function (event, loading) {
      if (!event) return;
      
      try {
        if (loading) {
          // Start loading
          event.classList.add("start", "loading");
          
          // Disable click events on loading overlays immediately
          document.querySelectorAll('.loading-overlay').forEach(overlay => {
            if (!overlay || !document.contains(overlay)) return;
            overlay.style.pointerEvents = 'none';
          });
        } else {
          // Stop loading
          event.classList.remove("start", "loading");
          event.classList.add("finish");
          
          // Clean up after brief transition
          setTimeout(() => {
            if (!event || !document.contains(event)) return;
            event.classList.remove("finish");
          }, 100);
        }
      } catch (error) {
        console.error('Error in toggleLoading:', error);
        // Safety cleanup
        if (event && document.contains(event)) {
          event.classList.remove("start", "loading", "finish");
        }
      }
    },

    updateUrl: function (url, searchParams = false) {
      try {
        if (searchParams) {
          const urlUpdate = `${window.location.pathname}?${searchParams}`;
          window.history.pushState({ url: urlUpdate }, "", urlUpdate);
        } else {
          window.history.pushState({ url: url }, "", url);
        }
      } catch (error) {
        console.error('Error updating URL:', error);
      }
    },
  };
})();
eventCollectionShopify.init();
})();